import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Box,
  useTheme,
  Divider
} from "@mui/material";
import ImageSlideshow from "../../components/ImageSlideShow";
import { ZoomInRounded } from "@mui/icons-material";
import TransitionsModal from "../../components/modal/modal";
import ImageSlider from "../../components/ImageSlider";
import { useState } from "react";
import Department from "./Department";
import ContentLayout from "../../components/ContentLayout";
import auditorium_img_1 from "../../assets/images/gallery/auditorium/auditorium1.jpg";
import auditorium_img_2 from "../../assets/images/gallery/auditorium/auditorium2.jpg";
import auditorium_img_3 from "../../assets/images/gallery/auditorium/auditorium3.jpg";
import auditorium_img_4 from "../../assets/images/gallery/auditorium/auditorium4.jpg";
import auditorium_img_5 from "../../assets/images/gallery/auditorium/auditorium5.jpg";
import classroom_img_1 from "../../assets/images/gallery/classroom/classroom1.jpg";
import classroom_img_2 from "../../assets/images/gallery/classroom/classroom2.jpg";
import classroom_img_3 from "../../assets/images/gallery/classroom/classroom3.jpg";
import classroom_img_4 from "../../assets/images/gallery/classroom/classroom4.jpg";
import classroom_img_5 from "../../assets/images/gallery/classroom/classroom5.jpg";
import seminarhall_img_1 from "../../assets/images/gallery/seminar/seminar_hall1.jpg";
import seminarhall_img_2 from "../../assets/images/gallery/seminar/seminar_hall2.jpg";
import seminarhall_img_3 from "../../assets/images/gallery/seminar/seminar_hall3.jpg";
import lab_img_1 from "../../assets/images/gallery/labs/lab1.jpg";
import lab_img_2 from "../../assets/images/gallery/labs/lab2.jpg";
import lab_img_3 from "../../assets/images/gallery/labs/lab3.jpg";
import lab_img_4 from "../../assets/images/gallery/labs/lab4.jpg";
import lab_img_5 from "../../assets/images/gallery/labs/lab5.jpg";
import lab_img_6 from "../../assets/images/gallery/labs/lab6.jpg";
import lab_img_7 from "../../assets/images/gallery/labs/lab7.jpg";
import lab_img_8 from "../../assets/images/gallery/labs/lab8.jpg";
import lab_img_9 from "../../assets/images/gallery/labs/lab9.jpg";
import lab_img_10 from "../../assets/images/gallery/labs/lab10.jpg";
import lab_img_11 from "../../assets/images/gallery/labs/lab11.jpg";
import lab_img_12 from "../../assets/images/gallery/labs/lab12.jpg";
import lab_img_13 from "../../assets/images/gallery/labs/lab13.jpg";
import lab_img_14 from "../../assets/images/gallery/labs/lab14.jpg";
import lab_img_15 from "../../assets/images/gallery/labs/lab15.jpg";
import lab_img_16 from "../../assets/images/gallery/labs/lab16.jpg";
import lab_img_17 from "../../assets/images/gallery/labs/lab17.jpg";
import lab_img_18 from "../../assets/images/gallery/labs/lab18.jpg";
import lab_img_19 from "../../assets/images/gallery/labs/lab19.jpg";
import lab_img_20 from "../../assets/images/gallery/labs/lab20.jpg";
import lab_img_21 from "../../assets/images/gallery/labs/lab21.jpg";
import lab_img_22 from "../../assets/images/gallery/labs/lab22.jpg";
import lab_img_23 from "../../assets/images/gallery/labs/lab23.jpg";
import lab_img_24 from "../../assets/images/gallery/labs/lab24.jpg";
import lab_img_25 from "../../assets/images/gallery/labs/lab25.jpg";
import lab_img_26 from "../../assets/images/gallery/labs/lab26.jpg";
import staffroom_img_1 from "../../assets/images/gallery/staff_room/staffroom1.jpg";
import staffroom_img_2 from "../../assets/images/gallery/staff_room/staffroom2.jpg";
import staffroom_img_3 from "../../assets/images/gallery/staff_room/staffroom3.jpg";
import staffroom_img_4 from "../../assets/images/gallery/staff_room/staffroom4.jpg";
import staffroom_img_5 from "../../assets/images/gallery/staff_room/staffroom5.jpg";
import staffroom_img_6 from "../../assets/images/gallery/staff_room/staffroom6.jpg";
import staffroom_img_7 from "../../assets/images/gallery/staff_room/staffroom7.jpg";
import staffroom_img_8 from "../../assets/images/gallery/staff_room/staffroom8.jpg";

type ImageType = {
  src: string;
  alt: string;
};

type InfraObect = {
  title: string;
  description?: string;
  img?: Array<ImageType>;
  subItems?: Array<{
    name: string;
    img: Array<ImageType>;
  }>;
};

const classroomData: Array<InfraObect> = [
  {
    title: "UG & PG Classrooms",
    description: "Well-equipped classrooms with A/V aids for teaching and learning process.",
    img: [
      { src: classroom_img_1, alt: "classroom_img_1" },
      { src: classroom_img_2, alt: "classroom_img_2" },
      { src: classroom_img_3, alt: "classroom_img_3" },
      { src: classroom_img_4, alt: "classroom_img_4" },
      { src: classroom_img_5, alt: "classroom_img_5" },
    ],
  }
]

const seminarhallData: Array<InfraObect> = [
  {
    title: "Seminar Halls",
    description: "",
    img: [
      { src: seminarhall_img_1, alt: "seminarhall_img_1" },
      { src: seminarhall_img_2, alt: "seminarhall_img_2" },
      { src: seminarhall_img_3, alt: "seminarhall_img_3" },
    ],
  },
]

const infrastructureData: Array<InfraObect> = [
  {
    title: "Skills Laboratories",
    img: [
      { src: lab_img_1, alt: "lab_img_1" },
      { src: lab_img_2, alt: "lab_img_2" },
      { src: lab_img_3, alt: "lab_img_3" },
      { src: lab_img_4, alt: "lab_img_4" },
      { src: lab_img_5, alt: "lab_img_5" },
      { src: lab_img_6, alt: "lab_img_6" },
      { src: lab_img_7, alt: "lab_img_7" },
      { src: lab_img_8, alt: "lab_img_8" },
      { src: lab_img_9, alt: "lab_img_9" },
      { src: lab_img_10, alt: "lab_img_10" },
      { src: lab_img_11, alt: "lab_img_11" },
      { src: lab_img_12, alt: "lab_img_12" },
      { src: lab_img_13, alt: "lab_img_13" },
      { src: lab_img_14, alt: "lab_img_14" },
      { src: lab_img_15, alt: "lab_img_15" },
      { src: lab_img_16, alt: "lab_img_16" },
      { src: lab_img_17, alt: "lab_img_17" },
      { src: lab_img_18, alt: "lab_img_18" },
      { src: lab_img_19, alt: "lab_img_19" },
      { src: lab_img_20, alt: "lab_img_20" },
      { src: lab_img_21, alt: "lab_img_21" },
      { src: lab_img_22, alt: "lab_img_22" },
      { src: lab_img_23, alt: "lab_img_23" },
      { src: lab_img_24, alt: "lab_img_24" },
      { src: lab_img_25, alt: "lab_img_25" },
      { src: lab_img_26, alt: "lab_img_26" },
    ],
  },

  {
    title: "Auditorium",
    img: [
      { src: auditorium_img_1, alt: "auditorium_img_1" },
      { src: auditorium_img_2, alt: "auditorium_img_2" },
      { src: auditorium_img_3, alt: "auditorium_img_3" },
      { src: auditorium_img_4, alt: "auditorium_img_4" },
      { src: auditorium_img_5, alt: "auditorium_img_5" }
    ],
  },

  {
    title: "Staff Rooms",
    img: [
      { src: staffroom_img_1, alt: "staffroom_img_1" },
      { src: staffroom_img_2, alt: "staffroom_img_2" },
      { src: staffroom_img_3, alt: "staffroom_img_3" },
      { src: staffroom_img_4, alt: "staffroom_img_4" },
      { src: staffroom_img_5, alt: "staffroom_img_5" },
      { src: staffroom_img_6, alt: "staffroom_img_6" },
      { src: staffroom_img_7, alt: "staffroom_img_7" },
      { src: staffroom_img_8, alt: "staffroom_img_8" },
    ],
  },
  
];

const Infrastructure = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [sliderImages, setSliderImages] = useState<Array<ImageType>>();
  const theme = useTheme();
  return (
    <ContentLayout>
      {/* Classroom */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.primary.contrastText }}>UG & PG Classrooms</Typography>
        </Grid>
        <Grid item xs={12} md={5}>
          <Box sx={{ position: "relative" }} >
            <ImageSlideshow sx={{}} images={classroomData[0]?.img as Array<ImageType>} showCaption={false} showCount={false} />
              <Box
                sx={{
                  position: "absolute" as "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                onClick={() => {
                  setTitle(classroomData[0]?.title);
                  setSliderImages(classroomData[0]?.img);
                  setOpen(true);
                } }
              >
                <ZoomInRounded
                  sx={{
                    color: "#fdd025",
                    zIndex: 99,
                    fontSize: "4rem",
                    "&:hover": {
                      fontSize: "6rem",
                    },
                  }} />
              </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
            Modern College of Physiotherapy boasts well-appointed classrooms, designed to foster an optimal learning environment. 
            Each classroom is equipped with modern amenities to enhance the teaching-learning process.
            Spacious and well-ventilated, these classrooms comfortably accommodate all students, ensuring an unhindered learning experience.
            To facilitate interactive and engaging sessions, the classrooms are furnished with projectors and screens, allowing for seamless display of presentations, videos, and other visual aids.
            Additionally, the availability of computers or laptops empowers faculty to incorporate technology effectively into their teaching methodologies.
            The classrooms are also equipped with a sufficient number of benches to provide ample seating for all students, ensuring a comfortable and conducive atmosphere for academic pursuits. 
          </Typography>
        </Grid>
      </Grid>

      {/* Seminar Hall */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Divider sx={{my:3}}/>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.primary.contrastText }}>Seminar Halls</Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
            Spacious and well-ventilated, the seminar hall comfortably accommodates all students, ensuring an unhindered learning experience.
            To facilitate interactive and engaging sessions, the seminar halls are furnished with projectors and screens, allowing for seamless display of presentations, videos, and other visual aids. 
          </Typography>
        </Grid>

        <Grid item xs={12} md={5}>
          <Box sx={{ position: "relative" }} >
            <ImageSlideshow sx={{}} images={seminarhallData[0]?.img as Array<ImageType>} showCaption={false} showCount={false} />
              <Box
                sx={{
                  position: "absolute" as "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                onClick={() => {
                  setTitle(seminarhallData[0]?.title);
                  setSliderImages(seminarhallData[0]?.img);
                  setOpen(true);
                } }
              >
                <ZoomInRounded
                  sx={{
                    color: "#fdd025",
                    zIndex: 99,
                    fontSize: "4rem",
                    "&:hover": {
                      fontSize: "6rem",
                    },
                  }} />
              </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Divider sx={{mb:4}}/>
        </Grid>
      </Grid>

        {infrastructureData.map((item, index) => {
          const hasSubtabs =
            item?.subItems?.length && ((item?.subItems?.length > 0) as boolean);

          const isMultiImages = Array.isArray(item.img) && item?.img?.length > 1;

          const imageToShow = (item?.img ? item?.img[0].src : "") as string;

          return (
            <>
              <Grid
                key={index}
                item
                p={2}
                mt={4}
                margin={"auto"}
                flexWrap={"wrap"}
                sx={{
                  minWidth: {
                    xs: "100%",
                    md: hasSubtabs ? "100%" : 400,
                  },
                  maxWidth: {
                    xs: "100%",
                    md: hasSubtabs ? "100%" : 400,
                  },
                }}
              >
                <Card
                  sx={{
                    alignContent: "space-between",
                    // margin: 4,
                    minWidth: {
                      xs: "100%",
                      md: hasSubtabs ? "100%" : 400,
                    },
                    maxWidth: {
                      xs: "100%",
                      md: hasSubtabs ? "100%" : 400,
                    },
                    minHeight: hasSubtabs ? "auto" : "380px",
                    maxHeight: hasSubtabs ? "auto" : { xs: "380px", sm: "380px" },
                  }}
                >
                  {!hasSubtabs && (
                    <>
                      {isMultiImages ? (
                        <Box sx={{ position: "relative" }}>
                          <ImageSlideshow
                            sx={{}}
                            images={item.img as Array<ImageType>}
                            showCaption={false}
                          />
                          <Box
                            sx={{
                              position: "absolute" as "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                            onClick={() => {
                              setTitle(item.title);
                              setSliderImages(item.img);
                              setOpen(true);
                            }}
                          >
                            <ZoomInRounded
                              sx={{
                                color: "#fdd025",
                                zIndex: 99,
                                fontSize: "4rem",
                                "&:hover": {
                                  fontSize: "6rem",
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      ) : (
                        <Box sx={{ position: "relative" }}>
                          <CardMedia
                            component="img"
                            height="240px"
                            sx={{
                              pt: 1,
                              margin: "auto",
                              objectFit: "cover",
                            }}
                            image={imageToShow}
                            alt={item.title as string}
                          />
                          <Box
                            sx={{
                              position: "absolute" as "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                            onClick={() => {
                              setTitle(item.title);
                              setSliderImages(item.img);
                              setOpen(true);
                            }}
                          >
                            <ZoomInRounded
                              sx={{
                                color: "#fdd025",
                                zIndex: 2,
                                fontSize: "4rem",
                                "&:hover": {
                                  fontSize: "6rem",
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      )}
                      <Divider sx={{ py: 1 }} />
                    </>
                  )}
                  <CardContent>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: "bold",
                          color: theme.palette.primary.contrastText,
                        }}
                      >
                        {item.title}
                      </Typography>

                      {item.description && (
                        <Typography
                          variant="subtitle1"
                          sx={{
                            textAlign: "left",
                            fontWeight: "bold",
                            fontSize: "1rem",
                            color: theme.palette.grey[900],
                            p: 2,
                          }}
                        >
                          {item.description}
                        </Typography>
                      )}
                    </Box>

                    {item?.subItems && (
                      <Box mt={2} sx={{ textAlign: "center", height: "60%" }}>
                        <Grid container spacing={2} mt={2}>
                          {item.subItems.map((subItem, idx) => {
                            const isMultiImages =
                              Array.isArray(subItem.img) &&
                              subItem?.img?.length > 1;

                            const imageToShow = (
                              subItem?.img ? subItem?.img[0].src : ""
                            ) as string;
                            return (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Card
                                  sx={{
                                    width: "80%",
                                    margin: 2,
                                    minHeight: "360px",
                                    // height: "60%",
                                    // maxHeight: { xs: "auto", sm: "360px" },
                                  }}
                                >
                                  {isMultiImages ? (
                                    <Box sx={{ position: "relative" }}>
                                      <ImageSlideshow
                                        sx={{}}
                                        images={subItem.img as Array<ImageType>}
                                        showCaption={false}
                                      />
                                      <Box
                                        sx={{
                                          position: "absolute" as "absolute",
                                          top: "50%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                        }}
                                        onClick={() => {
                                          setTitle(subItem.name);
                                          setSliderImages(subItem.img);
                                          setOpen(true);
                                        }}
                                      >
                                        <ZoomInRounded
                                          sx={{
                                            color: "#fdd025",
                                            zIndex: 99,
                                            fontSize: "4rem",
                                            "&:hover": {
                                              fontSize: "6rem",
                                            },
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                  ) : (
                                    <Box sx={{ position: "relative" }}>
                                      <CardMedia
                                        component="img"
                                        height="240px"
                                        sx={{
                                          pt: 1,
                                          margin: "auto",
                                          width: "80%",
                                          objectFit: "cover",
                                        }}
                                        image={imageToShow}
                                        alt={subItem.name as string}
                                      />
                                      <Box
                                        sx={{
                                          position: "absolute" as "absolute",
                                          top: "50%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                        }}
                                        onClick={() => {
                                          setTitle(subItem.name);
                                          setSliderImages(subItem.img);
                                          setOpen(true);
                                        }}
                                      >
                                        <ZoomInRounded
                                          sx={{
                                            color: "#fdd025",
                                            zIndex: 999,
                                            fontSize: "4rem",
                                            "&:hover": {
                                              fontSize: "6rem",
                                            },
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                  )}

                                  <CardContent>
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        fontWeight: "bold",
                                        color: theme.palette.primary.contrastText,
                                      }}
                                    >
                                      {subItem.name}
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              
            </>
          );
        })}

        {sliderImages && (
          <TransitionsModal
            open={open}
            setOpen={setOpen}
            title={title}
            children={
              <Grid item xs={12} margin={"auto"}>
                <Box sx={{ width: "75%", margin: "auto" }}>
                  <ImageSlider images={sliderImages} />
                </Box>
              </Grid>
            }
          />
        )}
        <Department/>
    </ContentLayout>
  );
};

export default Infrastructure;
